// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-products-wrap {
  border-radius: 14px;
  border: 3px solid #FFF;
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.1);
  margin-block: 20px 27px;
  padding-block: 22px 20px;
}
.vendor-products-wrap .no-product-data {
  text-align: center;
  padding: 15px;
}
.vendor-products-wrap .header-product-mobile {
  display: none;
}
.vendor-products-wrap .product-header-wrap {
  display: flex;
  width: 100%;
  max-width: 72%;
  gap: 40px;
  padding: 15px 20px;
  margin-inline: -3px;
}
.vendor-products-wrap .product-header-wrap .product-header-wrap-half {
  width: 50%;
  font-size: 16px;
  color: #333333;
  font-family: var(--font-family);
  line-height: 24px;
}
.vendor-products-wrap .merchant-product-wrap {
  display: flex;
  gap: 15px;
  width: 50%;
}
.vendor-products-wrap .merchant-product-bilddit-product-wrap {
  display: flex;
  gap: 40px;
  width: 100%;
  max-width: 72%;
  justify-content: space-between;
}
.vendor-products-wrap .product-request-btn-wrap {
  color: #3E7028;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding-top: 5px;
}
.vendor-products-wrap .product-request-msg {
  color: #4C5258;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}
.vendor-products-img-wrap {
  max-width: 80px;
  width: 100%;
}
.vendor-products-header {
  display: flex;
  justify-content: space-between;
  padding-inline: 20px;
}
.vendor-products-header .add-single-product-btn {
  margin-block: 8px;
  border-radius: 60px;
  background: #6ECB44;
  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  padding: 10px 20px;
}
.vendor-products-filter-wrap {
  display: flex;
  width: 100%;
  gap: 10px;
  padding-inline: 20px;
  padding-block: 13px 20px;
}
.vendor-products-filter-wrap .data_filter {
  display: flex;
  gap: 10px;
  width: 100%;
}
.vendor-products-filter-wrap .vendor-products-buttons-grp {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
}
.vendor-products-filter-wrap .vendor-products-buttons-grp button {
  color: #6ECB44;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding: 17px 20px;
  border-radius: 5px;
  border: 1px solid #6ECB44;
  background: #FFF;
  width: 100%;
  min-width: 75px;
}
.vendor-products-filter-wrap .vendor-products-buttons-grp .vendor-products-review-mapping-btn {
  width: 100%;
}
.vendor-products-filter-wrap .vendor-products-buttons-grp .vendor-products-review-mapping-btn a,
.vendor-products-filter-wrap .vendor-products-buttons-grp .vendor-products-review-mapping-btn button {
  color: #FFF;
  min-width: 165px;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding: 17px 20px;
  letter-spacing: 0.14px;
  border-radius: 60px;
  background: #6ECB44;
  width: 100%;
}
.vendor-products-filter-wrap .date-range-picker-wrap input::-webkit-input-placeholder {
  font-size: 14px;
}
.vendor-products-filter-wrap .date-clear-btn {
  opacity: 0.7;
  cursor: pointer;
}
.vendor-products-header-text {
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.vendor-products-vendor-name {
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.vendor-products-mapped-count {
  text-align: right;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.12px;
}
.vendor-products-mapping-status {
  color: #C96B6B;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.14px;
  background: #F8F9FA;
  margin-inline: -3px;
  padding: 10px;
}
.vendor-products--detail-container {
  padding: 20px;
  border-bottom: 1px solid #E4E6EA;
  margin-inline: -3px;
}
.vendor-products-content {
  display: flex;
  justify-content: space-between;
}
.vendor-products-content .sub-detail-seperator {
  margin-inline: 10px;
  font-size: 12px;
}
.vendor-products-img-wrap img {
  border-radius: 6px;
  border: 1px solid #F8F8F8;
  object-fit: contain;
}
.vendor-products-bagges-btn-wrap {
  max-width: 27%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.vendor-products-bagges-btn-wrap .selling-status-badge,
.vendor-products-bagges-btn-wrap .map-status-badge {
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.12px;
  padding: 3px 12px;
  border-radius: 60px;
}
.vendor-products-bagges-btn-wrap .selling-status-badge.selling,
.vendor-products-bagges-btn-wrap .map-status-badge.selling {
  background: #6ECB44;
}
.vendor-products-bagges-btn-wrap .selling-status-badge.mapped,
.vendor-products-bagges-btn-wrap .map-status-badge.mapped {
  background: #D4AE26;
}
.vendor-products-bagges-btn-wrap .selling-status-badge.not-selling,
.vendor-products-bagges-btn-wrap .map-status-badge.not-selling {
  background: #C96B6B;
}
.vendor-products-bagges-btn-wrap .selling-status-badge.unmapped,
.vendor-products-bagges-btn-wrap .map-status-badge.unmapped {
  background-color: #478EE2;
}
.vendor-products-bagges-btn-wrap .vendor-products-badges-grp {
  display: flex;
  gap: 10px;
}
.vendor-products-price-btn button {
  color: #3E7028;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  padding: 0;
  line-height: 14px;
  text-decoration-line: underline;
  border-radius: 0;
}
.vendor-products-middle-sub-detail-grp {
  display: block;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
.vendor-products-middle-sub-detail-grp div {
  padding-bottom: 2px;
}
.vendor-products-title {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: var(--primary-color);
  padding-bottom: 12px;
}
.vendor-products-id {
  line-height: 16px;
  padding-bottom: 10px;
  font-size: 14px;
}
.vendor-products-id span {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #333333;
}
.vendor-products-id span.vendor-products-id-value {
  font-weight: 500;
  color: #333333;
  padding-left: 4px;
}
.vendor-products-bottom-sub-detail-grp {
  display: flex;
  font-family: var(--font-family);
  color: #333333;
  align-items: center;
  min-height: 28px;
}
.vendor-products-bottom-sub-detail-grp span.sub-detail-price-value {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 10px;
}
.vendor-products-bottom-sub-detail-grp .sub-detail-qty span {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.vendor-products-wrap .new-app-version .vendor-products-filter-wrap {
  gap: 23px;
}
.vendor-products-wrap .new-app-version .vendor-products-filter-wrap .data_filter div {
  width: 100%;
}
.vendor-products-wrap .new-app-version .vendor-products-filter-wrap .vendor-products-buttons-grp {
  width: auto;
}
.vendor-products-wrap .new-app-version .vendor-products-filter-wrap .vendor-products-buttons-grp button {
  padding: 10px 15px;
  border-radius: 60px;
  width: auto;
  min-width: auto;
}
.vendor-products-wrap .new-app-version .vendor-products-filter-wrap .vendor-products-buttons-grp button:hover {
  background: var(--primary-color);
  color: #fff;
}
.vendor-products-wrap .new-app-version .vendor-products-sort-by-filter {
  background: #F8F9FA;
  margin-inline: -3px;
  display: flex;
  justify-content: flex-end;
  padding-inline: 22px;
  margin-bottom: 15px;
}

@media screen and (max-width: 1200px) and (min-width: 767px) {
  .vendor-products-wrap .new-app-version .vendor-products-filter-wrap .data_filter {
    display: grid;
    grid-template-columns: auto auto;
  }
  .vendor-products-wrap .new-app-version .vendor-products-filter-wrap .vendor-products-buttons-grp {
    align-items: self-start;
  }
  .vendor-products-middle-sub-detail-grp {
    font-size: 10px;
  }
  .vendor-products-id {
    padding-bottom: 10px;
    line-height: normal;
  }
}
@media screen and (max-width: 992px) {
  .vendor-products-filter-wrap {
    display: flex;
    width: 100%;
    gap: 15px;
    padding-inline: 20px;
    padding-block: 13px 20px;
    flex-direction: column;
  }
  .vendor-products .product-header-wrap {
    max-width: 75%;
  }
  .vendor-products .merchant-product-bilddit-product-wrap {
    max-width: 75%;
  }
  .vendor-products-bagges-btn-wrap {
    max-width: 25%;
  }
  .vendor-products-img-wrap {
    max-width: 60px;
    width: 100%;
  }
  .vendor-products-middle-sub-detail-grp .sub-detail-seperator {
    display: none;
  }
  .vendor-products--title {
    padding-bottom: 0px;
  }
  .vendor-products-id {
    padding-bottom: 5px;
  }
  .vendor-products-id span {
    font-size: 12px;
  }
  .vendor-products-title {
    padding-bottom: 10px;
  }
  .vendor-products-bagges-btn-wrap .vendor-products-badges-grp {
    flex-direction: column;
  }
  .vendor-products-wrap .new-app-version .vendor-products-filter-wrap .vendor-products-buttons-grp {
    align-items: self-start;
    justify-content: flex-start;
    flex-direction: row;
  }
}
@media screen and (max-width: 767px) {
  .vendor-products-filter-wrap {
    flex-direction: column;
  }
  .vendor-products-filter-wrap .data_filter {
    flex-direction: column;
  }
  .vendor-products-wrap .mobile_filter_wrapper {
    width: 100%;
    justify-content: flex-end;
    display: flex;
    padding-block: 5px 11px;
  }
  .vendor-products-wrap .merchant-product-bilddit-product-wrap {
    display: block;
  }
  .vendor-products-wrap .merchant-product-wrap {
    width: 100%;
  }
  .vendor-products-wrap .product-header-wrap {
    display: none;
  }
  .vendor-products-wrap .header-product-mobile:last-child:not(:has(+ .erp-product-detail)) {
    display: none;
  }
  .vendor-products-wrap .header-product-mobile {
    display: block;
    display: block;
    font-family: var(--font-family);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-block: 15px;
  }
  .vendor-products-bagges-btn-wrap .vendor-products-badges-grp {
    flex-direction: column;
  }
  .vendor-products-id {
    font-size: 12px;
    line-height: 15px;
    padding-block: 5px;
  }
  .vendor-products-bagges-btn-wrap {
    max-width: 28%;
    padding-top: 50px;
  }
  .vendor-products-middle-sub-detail-grp {
    line-height: 16px;
    gap: 4px;
  }
}
@media screen and (max-width: 492px) {
  .vendor-products-filter-wrap .vendor-products-buttons-grp {
    flex-direction: column;
  }
  .vendor-products-bagges-btn-wrap {
    max-width: 30%;
  }
  .vendor-products-bagges-btn-wrap .selling-status-badge,
  .vendor-products-bagges-btn-wrap .map-status-badge {
    font-size: 10px;
  }
  .vendor-products-mapped-count {
    text-align: start;
  }
  .vendor-products-header {
    flex-direction: column;
  }
  .vendor-products-title {
    font-size: 13px;
  }
  .vendor-products-id span {
    font-size: 11px;
  }
  .vendor-products-middle-sub-detail-grp {
    font-size: 11px;
    line-height: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/product-list/product-list.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qDAAA;EACA,uBAAA;EACA,wBAAA;AAAR;AAEQ;EACI,kBAAA;EACA,aAAA;AAAZ;AAGQ;EACI,aAAA;AADZ;AAIQ;EACI,aAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAFZ;AAIY;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;AAFhB;AAMQ;EACI,aAAA;EACA,SAAA;EACA,UAAA;AAJZ;AAOQ;EACI,aAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;AALZ;AAQQ;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AANZ;AASQ;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPZ;AAYI;EACI,eAAA;EACA,WAAA;AAVR;AAaI;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;AAXR;AAaQ;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAXZ;AAeI;EACI,aAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,wBAAA;AAbR;AAeQ;EACI,aAAA;EACA,SAAA;EACA,WAAA;AAbZ;AAgBQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;AAdZ;AAgBY;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAdhB;AAiBY;EACI,WAAA;AAfhB;AAiBgB;;EAEI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAfpB;AAqBY;EACI,eAAA;AAnBhB;AAuBQ;EACI,YAAA;EACA,eAAA;AArBZ;AA0BI;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxBR;AA2BI;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzBR;AA4BI;EACI,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AA1BR;AA6BI;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AA3BR;AA8BI;EACI,aAAA;EACA,gCAAA;EACA,mBAAA;AA5BR;AA+BI;EACI,aAAA;EACA,8BAAA;AA7BR;AA+BQ;EACI,mBAAA;EACA,eAAA;AA7BZ;AAmCQ;EAEI,kBAAA;EACA,yBAAA;EACA,mBAAA;AAlCZ;AAsCI;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;AApCR;AAsCQ;;EAEI,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AApCZ;AAsCY;;EACI,mBAAA;AAnChB;AAsCY;;EACI,mBAAA;AAnChB;AAsCY;;EACI,mBAAA;AAnChB;AAsCY;;EACI,yBAAA;AAnChB;AAwCQ;EACI,aAAA;EACA,SAAA;AAtCZ;AA0CI;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;AAxCR;AA2CI;EACI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzCR;AA2CQ;EACI,mBAAA;AAzCZ;AA6CI;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;AA3CR;AA8CI;EACI,iBAAA;EACA,oBAAA;EACA,eAAA;AA5CR;AA8CQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA5CZ;AA8CY;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;AA5ChB;AAiDI;EACI,aAAA;EACA,+BAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA/CR;AAiDQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA/CZ;AAkDQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhDZ;;AAyDQ;EAOI,SAAA;AA5DZ;AAuDgB;EACI,WAAA;AArDpB;AA2DY;EACI,WAAA;AAzDhB;AA2DgB;EACI,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAzDpB;AA2DoB;EACI,gCAAA;EACA,WAAA;AAzDxB;AA+DQ;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;AA7DZ;;AAkEA;EAKoB;IACI,aAAA;IACA,gCAAA;EAnEtB;EAsEkB;IACI,uBAAA;EApEtB;EA0EM;IACI,eAAA;EAxEV;EA6EM;IACI,oBAAA;IACA,mBAAA;EA3EV;AACF;AAgFA;EAEQ;IACI,aAAA;IACA,WAAA;IACA,SAAA;IACA,oBAAA;IACA,wBAAA;IACA,sBAAA;EA/EV;EAkFM;IACI,cAAA;EAhFV;EAmFM;IACI,cAAA;EAjFV;EAoFM;IACI,cAAA;EAlFV;EAsFM;IACI,eAAA;IACA,WAAA;EApFV;EAwFU;IACI,aAAA;EAtFd;EA0FM;IACI,mBAAA;EAxFV;EA2FM;IACI,mBAAA;EAzFV;EA2FU;IACI,eAAA;EAzFd;EA6FM;IACI,oBAAA;EA3FV;EA+FU;IACI,sBAAA;EA7Fd;EAuGc;IACI,uBAAA;IACA,2BAAA;IACA,mBAAA;EArGlB;AACF;AA2GA;EAGY;IACI,sBAAA;EA3Gd;EA6Gc;IACI,sBAAA;EA3GlB;EAkHU;IACI,WAAA;IACA,yBAAA;IACA,aAAA;IACA,uBAAA;EAhHd;EAmHU;IACI,cAAA;EAjHd;EAoHU;IACI,WAAA;EAlHd;EAqHU;IACI,aAAA;EAnHd;EAsHU;IACI,aAAA;EApHd;EAuHU;IACI,cAAA;IACA,cAAA;IACA,+BAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;EArHd;EA4HU;IACI,sBAAA;EA1Hd;EA+HM;IACI,eAAA;IACA,iBAAA;IACA,kBAAA;EA7HV;EAgIM;IACI,cAAA;IACA,iBAAA;EA9HV;EAkIM;IACI,iBAAA;IACA,QAAA;EAhIV;AACF;AAoIA;EAIgB;IACI,sBAAA;EArIlB;EA0IM;IACI,cAAA;EAxIV;EA0IU;;IAEI,eAAA;EAxId;EA4IM;IACI,iBAAA;EA1IV;EA6IM;IACI,sBAAA;EA3IV;EA8IM;IACI,eAAA;EA5IV;EA+IM;IACI,eAAA;EA7IV;EAiJM;IACI,eAAA;IACA,iBAAA;EA/IV;AACF","sourcesContent":[".vendor-products {\n    &-wrap {\n        border-radius: 14px;\n        border: 3px solid #FFF;\n        background: #fff;\n        box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.10);\n        margin-block: 20px 27px;\n        padding-block: 22px 20px;\n\n        .no-product-data {\n            text-align: center;\n            padding: 15px;\n        }\n\n        .header-product-mobile {\n            display: none;\n        }\n\n        .product-header-wrap {\n            display: flex;\n            width: 100%;\n            max-width: 72%;\n            gap: 40px;\n            padding: 15px 20px;\n            margin-inline: -3px;\n\n            .product-header-wrap-half {\n                width: 50%;\n                font-size: 16px;\n                color: #333333;\n                font-family: var(--font-family);\n                line-height: 24px;\n            }\n        }\n\n        .merchant-product-wrap {\n            display: flex;\n            gap: 15px;\n            width: 50%;\n        }\n\n        .merchant-product-bilddit-product-wrap {\n            display: flex;\n            gap: 40px;\n            width: 100%;\n            max-width: 72%;\n            justify-content: space-between;\n        }\n\n        .product-request-btn-wrap {\n            color: #3E7028;\n            text-align: right;\n            font-family: var(--font-family);\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n            padding-top: 5px;\n        }\n\n        .product-request-msg {\n            color: #4C5258;\n            text-align: right;\n            font-family: var(--font-family);\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n        }\n\n    }\n\n    &-img-wrap {\n        max-width: 80px;\n        width: 100%;\n    }\n\n    &-header {\n        display: flex;\n        justify-content: space-between;\n        padding-inline: 20px;\n\n        .add-single-product-btn {\n            margin-block: 8px;\n            border-radius: 60px;\n            background: #6ECB44;\n            color: #FFF;\n            text-align: center;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 14px;\n            padding: 10px 20px;\n        }\n    }\n\n    &-filter-wrap {\n        display: flex;\n        width: 100%;\n        gap: 10px;\n        padding-inline: 20px;\n        padding-block: 13px 20px;\n\n        .data_filter {\n            display: flex;\n            gap: 10px;\n            width: 100%;\n        }\n\n        .vendor-products-buttons-grp {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            justify-content: flex-end;\n            width: 100%;\n\n            button {\n                color: #6ECB44;\n                text-align: center;\n                font-family: var(--font-family);\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 20px;\n                padding: 17px 20px;\n                border-radius: 5px;\n                border: 1px solid #6ECB44;\n                background: #FFF;\n                width: 100%;\n                min-width: 75px;\n            }\n\n            .vendor-products-review-mapping-btn {\n                width: 100%;\n\n                a,\n                button {\n                    color: #FFF;\n                    min-width: 165px;\n                    text-align: center;\n                    font-family: var(--font-family);\n                    font-size: 14px;\n                    font-style: normal;\n                    font-weight: 500;\n                    line-height: 20px;\n                    padding: 17px 20px;\n                    letter-spacing: 0.14px;\n                    border-radius: 60px;\n                    background: #6ECB44;\n                    width: 100%;\n                }\n            }\n        }\n\n        .date-range-picker-wrap {\n            input::-webkit-input-placeholder {\n                font-size: 14px;\n            }\n        }\n\n        .date-clear-btn {\n            opacity: 0.7;\n            cursor: pointer;\n        }\n\n    }\n\n    &-header-text {\n        font-family: var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n    }\n\n    &-vendor-name {\n        font-family: var(--font-family);\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n    }\n\n    &-mapped-count {\n        text-align: right;\n        font-family: var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        letter-spacing: 0.12px;\n    }\n\n    &-mapping-status {\n        color: #C96B6B;\n        text-align: center;\n        font-family: var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 20px;\n        letter-spacing: 0.14px;\n        background: #F8F9FA;\n        margin-inline: -3px;\n        padding: 10px;\n    }\n\n    &--detail-container {\n        padding: 20px;\n        border-bottom: 1px solid #E4E6EA;\n        margin-inline: -3px;\n    }\n\n    &-content {\n        display: flex;\n        justify-content: space-between;\n\n        .sub-detail-seperator {\n            margin-inline: 10px;\n            font-size: 12px;\n        }\n    }\n\n    &-img-wrap {\n\n        img {\n\n            border-radius: 6px;\n            border: 1px solid #F8F8F8;\n            object-fit: contain;\n        }\n    }\n\n    &-bagges-btn-wrap {\n        max-width: 27%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-end;\n\n        .selling-status-badge,\n        .map-status-badge {\n            color: #FFF;\n            text-align: center;\n            font-family: var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 20px;\n            letter-spacing: 0.12px;\n            padding: 3px 12px;\n            border-radius: 60px;\n\n            &.selling {\n                background: #6ECB44;\n            }\n\n            &.mapped {\n                background: #D4AE26;\n            }\n\n            &.not-selling {\n                background: #C96B6B;\n            }\n\n            &.unmapped {\n                background-color: #478EE2;\n            }\n\n        }\n\n        .vendor-products-badges-grp {\n            display: flex;\n            gap: 10px;\n        }\n    }\n\n    &-price-btn button {\n        color: #3E7028;\n        text-align: right;\n        font-family: var(--font-family);\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 500;\n        padding: 0;\n        line-height: 14px;\n        text-decoration-line: underline;\n        border-radius: 0;\n    }\n\n    &-middle-sub-detail-grp {\n        display: block;\n        font-family: var(--font-family);\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 16px;\n\n        div {\n            padding-bottom: 2px;\n        }\n    }\n\n    &-title {\n        font-family: var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        color: var(--primary-color);\n        padding-bottom: 12px;\n    }\n\n    &-id {\n        line-height: 16px;\n        padding-bottom: 10px;\n        font-size: 14px;\n\n        span {\n            font-family: var(--font-family);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 16px;\n            color: #333333;\n\n            &.vendor-products-id-value {\n                font-weight: 500;\n                color: #333333;\n                padding-left: 4px;\n            }\n        }\n    }\n\n    &-bottom-sub-detail-grp {\n        display: flex;\n        font-family: var(--font-family);\n        color: #333333;\n        align-items: center;\n        min-height: 28px;\n\n        span.sub-detail-price-value {\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 10px;\n        }\n\n        .sub-detail-qty span {\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n        }\n    }\n\n\n}\n\n.vendor-products-wrap {\n    .new-app-version {\n        .vendor-products-filter-wrap {\n            .data_filter {\n                div {\n                    width: 100%;\n                }\n            }\n\n            gap: 23px;\n\n            .vendor-products-buttons-grp {\n                width: auto;\n\n                button {\n                    padding: 10px 15px;\n                    border-radius: 60px;\n                    width: auto;\n                    min-width: auto;\n\n                    &:hover {\n                        background: var(--primary-color);\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        .vendor-products-sort-by-filter {\n            background: #F8F9FA;\n            margin-inline: -3px;\n            display: flex;\n            justify-content: flex-end;\n            padding-inline: 22px;\n            margin-bottom: 15px;\n        }\n    }\n}\n\n@media screen and (max-width:1200px) and (min-width:767px) {\n    .vendor-products {\n        &-wrap {\n            .new-app-version {\n                .vendor-products-filter-wrap {\n                    .data_filter {\n                        display: grid;\n                        grid-template-columns: auto auto;\n                    }\n\n                    .vendor-products-buttons-grp {\n                        align-items: self-start;\n                    }\n                }\n            }\n        }\n\n        &-middle-sub-detail-grp {\n            font-size: 10px;\n\n\n        }\n\n        &-id {\n            padding-bottom: 10px;\n            line-height: normal;\n        }\n    }\n\n}\n\n@media screen and (max-width:992px) {\n    .vendor-products {\n        &-filter-wrap {\n            display: flex;\n            width: 100%;\n            gap: 15px;\n            padding-inline: 20px;\n            padding-block: 13px 20px;\n            flex-direction: column;\n        }\n\n        .product-header-wrap {\n            max-width: 75%;\n        }\n\n        .merchant-product-bilddit-product-wrap {\n            max-width: 75%;\n        }\n\n        &-bagges-btn-wrap {\n            max-width: 25%;\n        }\n\n\n        &-img-wrap {\n            max-width: 60px;\n            width: 100%;\n        }\n\n        &-middle-sub-detail-grp {\n            .sub-detail-seperator {\n                display: none;\n            }\n        }\n\n        &--title {\n            padding-bottom: 0px;\n        }\n\n        &-id {\n            padding-bottom: 5px;\n\n            span {\n                font-size: 12px;\n            }\n        }\n\n        &-title {\n            padding-bottom: 10px;\n        }\n\n        &-bagges-btn-wrap {\n            .vendor-products-badges-grp {\n                flex-direction: column;\n            }\n\n        }\n    }\n\n    .vendor-products-wrap {\n        .new-app-version {\n            .vendor-products-filter-wrap {\n\n                .vendor-products-buttons-grp {\n                    align-items: self-start;\n                    justify-content: flex-start;\n                    flex-direction: row;\n                }\n            }\n        }\n    }\n}\n\n@media screen and (max-width:767px) {\n    .vendor-products {\n        &-filter {\n            &-wrap {\n                flex-direction: column;\n\n                .data_filter {\n                    flex-direction: column;\n                }\n\n            }\n        }\n\n        &-wrap {\n            .mobile_filter_wrapper {\n                width: 100%;\n                justify-content: flex-end;\n                display: flex;\n                padding-block: 5px 11px;\n            }\n\n            .merchant-product-bilddit-product-wrap {\n                display: block;\n            }\n\n            .merchant-product-wrap {\n                width: 100%;\n            }\n\n            .product-header-wrap {\n                display: none;\n            }\n\n            .header-product-mobile:last-child:not(:has(+ .erp-product-detail)) {\n                display: none;\n            }\n\n            .header-product-mobile {\n                display: block;\n                display: block;\n                font-family: var(--font-family);\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n                padding-block: 15px;\n            }\n\n        }\n\n\n        &-bagges-btn-wrap {\n            .vendor-products-badges-grp {\n                flex-direction: column;\n            }\n\n        }\n\n        &-id {\n            font-size: 12px;\n            line-height: 15px;\n            padding-block: 5px;\n        }\n\n        &-bagges-btn-wrap {\n            max-width: 28%;\n            padding-top: 50px;\n\n        }\n\n        &-middle-sub-detail-grp {\n            line-height: 16px;\n            gap: 4px;\n        }\n    }\n}\n\n@media screen and (max-width:492px) {\n    .vendor-products {\n        &-filter {\n            &-wrap {\n                .vendor-products-buttons-grp {\n                    flex-direction: column;\n                }\n            }\n        }\n\n        &-bagges-btn-wrap {\n            max-width: 30%;\n\n            .selling-status-badge,\n            .map-status-badge {\n                font-size: 10px;\n            }\n        }\n\n        &-mapped-count {\n            text-align: start;\n        }\n\n        &-header {\n            flex-direction: column;\n        }\n\n        &-title {\n            font-size: 13px;\n        }\n\n        &-id span {\n            font-size: 11px;\n\n        }\n\n        &-middle-sub-detail-grp {\n            font-size: 11px;\n            line-height: 14px;\n        }\n    }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
